import { create } from 'zustand';

interface ErrorState {
    isOnline: boolean;
    setIsOnline: (token: this['isOnline']) => void;
}

export const useErrorStore = create<ErrorState>()(set => ({
    isOnline: true,
    setIsOnline: isOnline => set(() => ({ isOnline })),
}));
